<template>
  <div>
    <h2 class="instH2">Подтвердите паспортные данные</h2>
    <div id="pasSmartId">
      <imageInput v-on:imageData="imageData"></imageInput>
    </div>
    <!-- <formInput :refs="'PASSPORT_SERIES'"></formInput> -->
    <instInput :fieldName="'PASSPORT_SERIES'"></instInput>
    
    <!-- <formInput :refs="'PASSPORT_NUMBER'"></formInput> -->
    <instInput :fieldName="'PASSPORT_NUMBER'"></instInput>

    <!-- <formInput :refs="'PASSPORT_DEP_CODE'"></formInput> -->
    <instInput :fieldName="'PASSPORT_DEP_CODE'"></instInput>

    <!-- <formInput :refs="'PASSPORT_DATE'"></formInput> -->
    <instInput :fieldName="'PASSPORT_DATE'"></instInput>

    <!-- <formInput :refs="'BIRTHPLACE'"></formInput> -->
    <instInput :fieldName="'BIRTHPLACE'"></instInput>

    <!-- <formInput :refs="'BIRTHDAY'"></formInput> -->
    <instInput :fieldName="'BIRTHDAY'"></instInput>

    <!-- <formSelectDadata :refs="'PASSPORT_DEP'"></formSelectDadata> -->
    <instDadata :fieldName="'PASSPORT_DEP'"></instDadata>
    
    <!-- <formInput :refs="'SNILS'"></formInput> -->
    <instInput :fieldName="'SNILS'"></instInput>
    
    <!-- <formSelectDadata :refs="'RESIDENTIAL_ADDRESS'"></formSelectDadata> -->
    <instDadata :fieldName="'RESIDENTIAL_ADDRESS'"></instDadata>

    <!-- <formCheckBox :name="'IS_ADDRESS_COINCIDES'" :trueValue="'Y'" :falseValue="'N'"></formCheckBox> -->
    <instCheckBox :fieldName="'IS_ADDRESS_COINCIDES'"></instCheckBox>
    
    <!-- <formSelectDadata :refs="'REGISTRATION_ADDRESS'"></formSelectDadata> -->
    <instDadata :fieldName="'REGISTRATION_ADDRESS'"></instDadata>
    
    <!-- <div id="sex">Ваш пол:
      <formRadio :refs="'GENDER'" :sman="'M'"></formRadio>
      <formRadio :refs="'GENDER'" :sman="'F'"></formRadio>
      <span class="errorMsg" v-if="genderVuex.ShowError">{{ genderVuex.msg }}</span>
    </div> -->
    <instSelect :fieldName="'GENDER'"></instSelect> 
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "passport",
  data() {
    return {
      foto: '',
      smartIdKeyAlias: {
        authority: 'PASSPORT_DEP',
        authority_code: 'PASSPORT_DEP_CODE',
        birthdate: 'BIRTHDAY',
        birthplace: 'BIRTHPLACE',
        // gender: 'GENDER',
        issue_date: 'PASSPORT_DATE',
        // name: 'FIRST_NAME',
        number: 'PASSPORT_NUMBER',
        number_page2: 'PASSPORT_NUMBER',
        number_page3: 'PASSPORT_NUMBER',
        // patronymic: 'SECOND_NAME',
        series: 'PASSPORT_SERIES',
        series_page2: 'PASSPORT_SERIES',
        // surname: 'LAST_NAME',
      },
    }
  },
  components: {
    // formInput: () => import('@/views/pdlloan/formInput'),
    // formSelectDadata: () => import('@/views/pdlloan/formSelectDadata'),
    // formSelectDadataPassport: () => import('@/views/pdlloan/formSelectDadataPassport'),
    // formCheckBox: () => import('@/views/pdlloan/formCheckBox'),
    imageInput: () => import('@/components/form/imageInput.vue'),
    // formRadio: () => import('@/views/pdlloan/formRadio'),
    instInput: () => import('@/components/inst/instInput.vue'),
    instDadata: () => import('@/components/inst/instInputDadata.vue'),
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
    instSelect: () => import('@/components/inst/instSelect.vue'),
  },
  mounted() {
    this.$emit('scrollingTo', {
      id: 'zform',
    });
  },
  watch: {},
  methods: {
    imageData(value) {
      this.foto = value.value;
      this.fotoSmartId();
    },
    fotoSmartId() {
      this.$store.dispatch('showLoading');
      this.$palantir.trackAction(146, '');
      this.$myApi.singleRequest({action: 'fotoPass', fotoPas: this.foto,}).then(res => {
        this.$palantir.trackAction(147, JSON.stringify(res));
        for (let item in this.smartIdKeyAlias) {
          if (res['SmartID'][item] != undefined) {
            this.$store.dispatch('saveSendData', {target: this.smartIdKeyAlias[item], value: res['SmartID'][item]});
          }
        }
        this.$store.dispatch('saveSendData', {target: 'smartIdFileID', value: res.fileId.file_id});
        try {
          this.$external.traceInput({
            action: 165,
            refs: 'smartIdFileID',
            value: res.fileId.file_id
          });
        } catch (e) {
          console.log(e)
        }
        this.$store.dispatch('hideLoading');
      }).catch(res => {
        this.$palantir.trackAction(148, JSON.stringify(res));
        let ErrorResult = this.$myApi.parseError(res, 'fio smartID');
        this.$external.traceInput({action: 165, refs: 'smartIdFileID', value: -1});
        this.$store.dispatch('saveSendData',{target:'smartIdFileID', value: -1});
        if (ErrorResult.ExecutionErrorCode > 0) {
          alert(ErrorResult.ExecutionErrorMessage);
        }
      }).finally(() => {
        this.$store.dispatch('hideLoading');
      });
    },
  },
  computed: {
    ...mapState({
      genderVuex: state => state.Form.workData.GENDER,
    }),
  },
}
</script>
<style scoped>
.instH2{margin-top: 0;}

/* /deep/ .checkBoxWrap {
  margin-bottom: 4.71vw
}

#sex { display: flex; align-items: center; padding: 6.47vw 0 0 11.76vw; color: rgba(19,21,21,.7019607843137254); font-weight: 500; position: relative }

@media (min-width: 760px) {
  /deep/ .checkBoxWrap {
    margin-bottom: 1.29vw
  }
  #sex { padding: 3.95vw 0 0 1.76vw }
}

@media (min-width: 1240px) {
  /deep/ .checkBoxWrap {
    margin-bottom: 16px
  }
  #sex { padding: 0 0 0 10px }
} */
</style>
